const styles = theme => ({
  propertyDetailButtonRotateIcon: {
    transform: 'rotateY(180deg)',
  },
  selectAllContainer: {
    padding: '14px',
    background: theme.palette.primary.grey,
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginTop: '24px',
  },

  inputCheckbox: {
    margin: '0',
    padding: '0',

    '& > span.MuiButtonBase-root': {
      width: '20px',
      height: '20px',
      margin: '0',
      padding: '0',
    },

    '& > span.MuiTypography-root': {
      color: theme.palette.primary.adgmBlack,
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '24px',
      marginLeft: '8px',
    },
  },

  propertyInfoList: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    flexWrap: 'wrap',
  },
  propertyInfoContainer: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  propertyInfoIcon: {
    marginRight: '8px',
  },
  propertyInfoText: {
    color: '#595B61',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '21px',
    whiteSpace: 'nowrap',
    '&::before': {
      display: 'inline-flex',
      marginRight: '8px',
      content: '""',
      width: '4px',
      height: '4px',
      borderRadius: '2px',
      background: '#D5D6D7',
    },
  },

  loadingContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: '#484456',
    opacity: '0.9',
    top: '0',
    left: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100,
    cursor: 'wait',
    '& div': {
      textAlign: 'center',
      '& img': {
        marginBottom: '10px',
      },
    },
    '& p': {
      color: '#FFFFFF',
      fontWeight: 500,
      fontSize: '14px',
    },
  },

  disableCard: {
    PointerEvent: 'none',
  },

  roundedButton: {
    padding: '20px',
    borderRadius: '50%',
    // height: '50px',
    // width: '50px',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  arrowWidth: {
    width: '20px',
  },
  avatar: {
    height: 63,
    width: 63,
    display: 'inline-flex',
  },
  title: {
    fontWeight: '600',
    marginBottom: '0',
    wordBreak: 'break-word',
  },
  subTitle: {},

  sectionMargin: {
    marginBottom: '8px',
  },

  containerItem: {
    padding: '20px 8px',
  },

  listItemContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    background: '#FFFFFF',
    border: '1px solid #CED1D6',
    borderRadius: '0px',

    '&:hover': {
      background: theme.palette.primary.cardHover,
      border: `1px solid ${theme.palette.primary.cardHoverBorder}`,
    },
    '&:focus': {
      background: theme.palette.primary.cardHover,
      border: `1px solid ${theme.palette.primary.cardHoverBorder}`,
    },

    '&:not(:last-child)': {
      marginBottom: '26px',
    },
    '& > a > div': {
      whiteSpace: 'initial',
    },
    '& div > div': {
      whiteSpace: 'initial',
    },
  },

  listItemContainerChecked: {
    background: theme.palette.primary.cardHover,
  },
  detailButton: {
    background: 'transparent',
  },
  listItemContent: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '20px',
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  contentTitle: {
    fontSize: '12px',
    fontWeight: '400',
    color: '#484456',
    textTransform: 'capitalize',
  },
  contentSubTitle: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#130F26',
  },
  divider: {
    width: '100%',
    margin: '16px 0px',
    backgroundColor: '#EBEEF3',
  },

  listItemIcon: {
    minWidth: 'auto',
    marginRight: '11px',
  },
  itemCheckbox: {
    '& svg': {
      height: '25px',
      width: '25px',
    },
  },
  itemCheckboxChecked: {
    color: `${theme.palette.primary.main} !important`,
  },
  itemCheckboxIndeterminate: {
    color: '#237E7C !important',
  },

  viewSelectedPlotsBtn: {
    background: 'transparent !important',
    color: theme.palette.primary.adgmSkyBlue,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '21px',
    textTransform: 'capitalize',
    borderRadius: '12px',
  },

  propertyDetailButton: {
    fontWeight: '500 !important',
    fontSize: '14px !important',
    color: `${theme.palette.primary.main}!important`,
    textTransform: 'none !important',
    whiteSpace: 'nowrap',
    alignSelf: 'center',
  },

  listItemText: {
    display: 'flex',
    flexWrap: 'wrap',

    '& $item': {
      padding: '0',
      //  overflow: 'hidden',
      marginBottom: '4px',
      // marginRight: '12px',
      '& p': {
        fontSize: '14px',
        whiteSpace: 'normal',
      },
      '& $subTitle': {
        display: 'none',
      },
    },
    '& $title': {
      fontSize: '14px',
    },
    '& $subTitle': {
      color: theme.palette.primary.dim,
    },
  },
  item: {},
  avatarItem: {},
  listItemAction: {
    right: '46px',
  },
  listItemActionModified: {
    right: '80px',
  },
  listItemActionArrow: {},
  badgeButton: {
    background: theme.palette.primary.infoBlueLight,
    color: theme.palette.primary.infoBlue,
    textTransform: 'none',
    border: '1px solid #1270B4',
    borderRadius: '10px',
    padding: '6px',
    width: '124px',
    '& p': {
      fontSize: '14px',
      fontWeight: 500,
    },
    '& span': {
      '& > span': {
        margin: '0px 2px',
      },
    },
  },
  adgmAlert: {
    width: '100%',
    '& a': {
      marginLeft: '4px',
    },
  },
  badgeButtonModified: {
    background: theme.palette.primary.infoBlueLight,
    color: theme.palette.primary.infoBlue,
    textTransform: 'none',
    border: '1px solid #1270B4',
    borderRadius: '10px',
    padding: '6px',
    // width: '90px',
    '& p': {
      fontSize: '14px',
      fontWeight: 500,
    },
    '& span': {
      '& > span': {
        margin: '0px 2px',
      },
    },
  },
  typeChip: {
    background: theme.palette.primary.serviceChip,
    color: theme.palette.primary.adgmBlack,
    fontSize: '12px',
    fontWeight: '500',
    padding: '3px 12px',
    borderRadius: '0px',
  },
  studioColor: {
    background: theme.palette.primary.serviceChip,
  },
  badgePill: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      '& div': {
        height: '8px',
        width: '8px',
        borderRadius: '8px',
      },
      '& span': {
        fontSize: '12px',
        fontWeight: '500',
        color: '#484456',
      },
    },
  },

  pill: {
    marginRight: '0.5rem',
    marginLeft: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& div': {
      height: '6px',
      width: '6px',
      backgroundColor: '#CED1D6',
      borderRadius: '6px',
    },
    '& span': {
      fontSize: '14px',
      fontWeight: '400',
      color: '#484456',
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0',
    },
  },

  ownerPill: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '& div': {
        width: '6px',
        height: '6px',
        backgroundColor: '#CED1D6',
        borderRadius: '6px',
      },
      '& span': {
        fontSize: '14px',
        fontWeight: '400',
        color: '#484456',
      },
    },
  },

  collapsedList: {
    background: '#fff',
  },
  collapsedListItem: {
    padding: '10px 5%',
  },

  listItem: {
    whiteSpace: 'initial',
  },

  danger: {
    backgroundColor: '#DF2C2C',
  },
  warning: {
    backgroundColor: '#D97706',
  },
  success: {
    background: '#008558',
  },
  info: {
    backgroundColor: '#1270B4',
  },
  dim: {
    backgroundColor: '#8C9099',
  },

  collapsedListItemText: {
    gridTemplateColumns: '25% 20% 20% 20% 15% !important',
    '& > div:nth-child(4), & > div:nth-child(5)': {
      borderRight: 'none !important',
    },
  },
  collapsedAvatarItem: {
    '& > div:last-child': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  collapsedBadge: {
    width: '100%',
  },

  // Modal Styles

  selectedPlotsModal: {
    height: '90vh',
    maxHeight: '90vh',
    width: '65vw',
    maxWidth: '1000px',
    padding: '0',
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',

    [theme.breakpoints.down('sm')]: {
      height: '100vh',
      maxHeight: '100vh',
      width: '100vw',
      maxWidth: '100vw',
      boxShadow: 'none',
      borderRadius: '0',
    },
  },

  selectedPlotsTitleContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    gap: '10px',
    padding: '16px',

    [theme.breakpoints.down('sm')]: {
      padding: '24px 16px 16px 16px',
    },
  },

  selectedPlotsTitle: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '150%',
  },

  closeBtn: {
    minHeight: 'auto',
    minWidth: 'auto',
    background: 'transparent',
    border: '0 !important',
    padding: '5px !important',
    boxShadow: 'none !important',
    borderRadius: '50%',
  },

  selectedPlotsModalContent: {
    width: '100%',
    flex: '1',
    padding: '24px 16px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },

  propertyCardsList: {
    width: '100%',
    flex: '1',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },

  selectedPlotsModalPagination: {
    margin: '24px 0 0 0',
  },

  selectedPlotsModalFooter: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '16px',
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
  },

  resetBtn: {
    minHeight: 'auto',
    minWidth: 'auto',
    background: 'transparent !important',
    color: theme.palette.secondary.dim,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '150%',
    textTransform: 'lowercase',
    border: '0 !important',
    boxShadow: 'none !important',
    padding: '10px',
    whiteSpace: 'noWrap',

    '& .MuiButton-label span::first-letter': {
      textTransform: 'uppercase',
    },
  },

  closeModalBtn: {
    minHeight: 'auto',
    minWidth: 'auto',
    background: theme.palette.primary.white,
    color: theme.palette.primary.adgmBlack,
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '21px',
    textTransform: 'capitalize',
    padding: '12px 40px',
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    borderRadius: '4px',
    boxShadow: 'none',
    whiteSpace: 'noWrap',

    '&:hover': {
      background: theme.palette.primary.white,
      color: theme.palette.primary.adgmBlack,
    },

    '& .MuiButton-label span::first-letter': {
      textTransform: 'uppercase',
    },

    [theme.breakpoints.down('sm')]: {
      padding: '12px 30px',
    },
  },

  [theme.breakpoints.up('md')]: {
    listItem: {
      '& .MuiListItemText-root': {
        marginTop: '0px',
        marginBottom: '0px',
      },
    },
    listItemBuilding: {
      paddingRight: '10.4rem',
    },
    listItemText: {
      display: 'grid',
      gridTemplateColumns: '25% 13% 13% 10% 11% 13% 15%',
      '& $item': {
        borderLeft: '1px solid #EBEEF3',
        padding: '0 10px',
        '@media (max-width: 1250px)': {
          padding: '0 5px',
        },
        minWidth: 'auto',
        marginBottom: '0',
        '& $subTitle': {
          display: 'block',
        },
      },
      '& $avatarItem': {
        borderLeft: 'none',
        paddingLeft: '0px',
        width: 'auto',
        marginBottom: '0',
        '& $avatar': {
          height: 63,
          width: 63,
        },
      },
    },
    listItemTextBuilding: {
      gridTemplateColumns: '25% 17% 17% 12% 12% 17% !important',
      '& $item': {
        '&:last-child': {
          borderRight: '1px solid #EBEEF3',
        },
      },
    },
    collapsedList: {
      background: '#F8F8F8',
    },
  },

  [theme.breakpoints.down('sm')]: {
    badgePill: {
      justifyContent: 'flex-start',
    },
    title: {
      fontSize: '16px',
    },
    mobileMargin: {
      marginBottom: '16px',
    },

    containerItem: {
      padding: '12px 0px',
    },
    listItemBuilding: {
      paddingRight: '16px',
      flexDirection: 'column',
    },
    listItemAction: {
      right: '0',
      width: '100%',
      position: 'static',
      padding: '0 16px 10px',
      transform: 'none',
      display: 'inline-block',
    },
    listItemActionModified: {
      right: '0',
      top: '5px',
      width: 'auto',
      position: 'absolute',
      padding: '0 16px 10px',
      transform: 'none',
      display: 'inline-block',
    },
    listItemActionArrow: {
      right: '0',
      bottom: '5px',
      width: 'auto',
      position: 'absolute',
      padding: '0 16px',
      transform: 'none',
      display: 'inline-block',
      top: 'unset',
    },
    badgeButton: {
      borderRadius: '4px',
      width: '100%',
      '& p': {
        fontSize: '12px',
        '& + span': {
          marginLeft: 'auto',
        },
      },
      '& span': {
        alignItems: 'center',
        justifyContent: 'flex-start',
        margin: '0px',
        '& > span': {
          margin: '0px 6px',
        },
      },
    },
    badgeButtonModified: {
      bottom: 0,
      borderRadius: '4px',
      width: '100%',
      '& p': {
        fontSize: '12px',
        '& + span': {
          marginLeft: 'auto',
        },
      },
      '& span': {
        alignItems: 'center',
        justifyContent: 'flex-start',
        margin: '0px',
        '& > span': {
          margin: '0px 6px',
        },
      },
    },
    listItemText: {
      '& $item': {
        color: theme.palette.primary.darkGrey,
        display: 'inline-flex',
        alignItems: 'center',
        '&:nth-child(6)': {
          width: '100%',
        },
        '& img': {
          marginRight: '4px',
        },
        '& svg': {
          width: '16px',
          marginRight: '4px',
        },
      },
      '& $avatarItem': {
        color: theme.palette.secondary.main,
      },
      '& $Localityitem': {
        width: '100%',
      },
    },
    Localityitem: {},
    listItemIcon: {
      minWidth: 'auto',
      marginRight: '0',
      position: 'absolute',
      right: '0',
      top: '0',
    },
    collapsedListItem: {
      borderBottom: '1px solid #EBEEF3',
      '&:last-child': {
        borderBottom: '0',
      },
    },
    collapseListItemIcon: {
      minWidth: 'auto',
      marginRight: '0',
      position: 'absolute',
      right: '0',
      top: '0',
    },
    roundedButton: {
      padding: '15px',
      borderRadius: '50%',
      // height: '50px',
      // width: '50px',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
    arrowWidth: {
      width: '15px',
    },
  },
});

export default styles;
